import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentEducationService } from '@crm/shared/persons/types';

@Injectable({
  providedIn: 'root',
})
export class PersonEducationServicePageSharedService {
  private withCrm1EducationServices$: Observable<StudentEducationService[]>;
  private educationServices$: Observable<StudentEducationService[]>;

  getWithCrm1EducationServices(): Observable<StudentEducationService[]> {
    return this.withCrm1EducationServices$;
  }

  getEducationServices(): Observable<StudentEducationService[]> {
    return this.educationServices$;
  }

  setWithCrm1EducationServices(withCrm1EducationServices$: Observable<StudentEducationService[]>): void {
    this.withCrm1EducationServices$ = withCrm1EducationServices$;
  }

  setEducationServices(educationServices$: Observable<StudentEducationService[]>): void {
    this.educationServices$ = educationServices$;
  }
}
